/**
 * Decisão de gating do fluxo "Chamado sem Login" a partir da resposta pública do QR Code.
 *
 * O endpoint `GET /v1/qrcode/public` retorna, em `site.empresaObj`, os flags configurados
 * pela empresa em `/configuracoes/abertura-chamado`. Como esse payload é público, o
 * `LandingQR` consegue decidir o destino do QR antes de qualquer login.
 *
 * - `habilitarChamadoSemLogin`   → empresa habilitou o formulário sem login.
 * - `habilitarDestinoQrCodeChamado` → destino do QR: `true` = formulário direto,
 *                                     `false` = página do ativo (com botão "Abrir chamado").
 */

// Empresa de homologação usada pelo atalho `?debug`.
const DEBUG_EMPRESA_ID = 4157;

interface QrCodePublicEmpresaObj {
  habilitarChamadoSemLogin?: boolean | null;
  habilitarDestinoQrCodeChamado?: boolean | null;
  habilitarNotificacaoEmitenteSemLogin?: boolean | null;
}

interface QrCodePublicData {
  site?: {
    empresa?: number;
    empresaObj?: QrCodePublicEmpresaObj | null;
  } | null;
}

export interface SemLoginGateDecision {
  /** Empresa habilitou o formulário sem login (ou está em modo debug). */
  semLoginEnabled: boolean;
  /** Destino do QR é o formulário direto (true) ou a página do ativo (false). */
  directForm: boolean;
  /** Empresa notifica o emitente por e-mail (torna Nome e E-mail obrigatórios). */
  notifyByEmail: boolean;
  /** Empresa a usar no fluxo — forçada para a empresa de homologação em modo debug. */
  empresaId?: number;
}

export function semLoginGate(data: QrCodePublicData, debug: boolean): SemLoginGateDecision {
  const empresaObj = data?.site?.empresaObj;
  const empresa = data?.site?.empresa;

  const configEnabled = empresaObj?.habilitarChamadoSemLogin === true;

  const semLoginEnabled = debug || configEnabled;
  const directForm = debug || empresaObj?.habilitarDestinoQrCodeChamado === true;
  const notifyByEmail = empresaObj?.habilitarNotificacaoEmitenteSemLogin === true;
  const empresaId = debug ? DEBUG_EMPRESA_ID : empresa;

  return { semLoginEnabled, directForm, notifyByEmail, empresaId };
}
